export default "__VITE_ASSET__CQiv1lnp__"